import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async createLine(
        { commit, dispatch },
        { active, content, images, keywords, name, parentSlug, slug, summary }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/lines", {
                name,
                content,
                summary,
                slug,
                keywords,
                images,
                parentSlug,
                active
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async listLinesPaginated(
        { commit, dispatch },
        {
            active,
            complete,
            highlightType,
            itemsByPage,
            keyword,
            lineSlug,
            orderBy,
            orderType,
            page,
            type
        }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/lines", {
                params: {
                    active,
                    complete,
                    highlightType,
                    itemsByPage,
                    keyword,
                    orderBy,
                    orderType,
                    page,
                    type,
                    parentSlug: lineSlug
                }
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async listSublinesByLine({ commit, dispatch }, { active, lineSlug }) {
        try {
            const { data } = await Http.instance.get("/bo/lines", {
                params: { active, parentSlug: lineSlug, itemsByPage: 100 }
            });
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async listAllLines({ commit, dispatch }, { active, keyword }) {
        try {
            const { data } = await Http.instance.get("/bo/lines/all", {
                params: { active, keyword }
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async getLineBySlug({ commit, dispatch }, { slug }) {
        try {
            const { data } = await Http.instance.get(`/bo/lines/${slug}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async updateLine(
        { commit, dispatch },
        {
            active,
            content,
            highlightType,
            images,
            keywords,
            name,
            parentSlug,
            slug,
            summary
        }
    ) {
        try {
            const { data } = await Http.instance.patch(`/bo/lines/${slug}`, {
                name,
                content,
                highlightType,
                summary,
                keywords,
                active,
                images,
                parentSlug
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async deleteLine({ commit, dispatch }, { slug }) {
        try {
            await Http.instance.delete(`/bo/lines/${slug}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async updateLineFilters({ commit, dispatch }, { filters, lineSlug }) {
        try {
            await Http.instance.patch(`/bo/lines/${lineSlug}/filters`, {
                filters
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async updateLinesWeights({ commit, dispatch }, { lines }) {
        try {
            await Http.instance.put("/bo/lines/massive/weights", { lines });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async updateLineCollections(
        { commit, dispatch },
        { collectionsSlugs, lineSlug }
    ) {
        try {
            await Http.instance.put(`/bo/lines/${lineSlug}/collections`, {
                collectionsSlugs
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    },

    async updateLineBrands({ commit, dispatch }, { brandsSlugs, lineSlug }) {
        try {
            await Http.instance.put(`/bo/lines/${lineSlug}/brands`, {
                brandsSlugs
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_LINES", parseError);
            throw parseError;
        }
    }
};

export default actions;
